/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Language_PlaceholderInputs */

const en_user_language_placeholder = /** @type {(inputs: User_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en`)
};

const ja_user_language_placeholder = /** @type {(inputs: User_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ja`)
};

const fr_user_language_placeholder = /** @type {(inputs: User_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fr`)
};

const de_user_language_placeholder = /** @type {(inputs: User_Language_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de`)
};

/**
* | output |
* | --- |
* | "en" |
*
* @param {User_Language_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_language_placeholder = /** @type {((inputs?: User_Language_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Language_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_language_placeholder(inputs)
	if (locale === "ja") return ja_user_language_placeholder(inputs)
	if (locale === "fr") return fr_user_language_placeholder(inputs)
	return de_user_language_placeholder(inputs)
});